import { co2OptBaseApi } from '../axios.config';

export const getStatusesReports = async (access_token, page_no, per_page) => {
  return await co2OptBaseApi
    .get(`messenger/job-list`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      params: {
        page_no,
        per_page,
      },
    })
    .then(res => res)
    .catch(function (error) {
      console.error('E20103', error);
      if (error.response) {
        return error.response;
      }
    });
};
